import React, { useContext } from 'react';
import { makeStyles } from "@material-ui/core"


import { UserContext } from "../Contexts/UserContext/UserContext.js";
import { appConfig } from '../config.js';
import MenuPanelHeader from './MenuPanelHeader.js';


const useStyles = makeStyles({
	wallet_card_style: {
		// justifyContent: "center",
		justifyContent: "left",
		display: "flex",
		flexDirection: "column",
		fontSize: "16px",
		// padding: "0.6em 0.5em",
	},
});

/**
 * props:
 * 		- onClick 	(callback)
 */
export function ActiveTokenCard(props) {

	const userContext = useContext(UserContext)
	const theme = appConfig.theme
	const classes = useStyles()

	// let's change background color if this menuItem is selected
	const num = String(props.num)
	const is_selected_tab = String(num) === String(props.focus_num)
	const custom_style = {}
	// if (is_selected_tab) {
	// 	custom_style.background = theme.backgroundColorDarker1
	// } else {
	// 	custom_style.background = navbarItemBackground
	// }

	const coinProps = userContext.get_selected_coin_props()


	return (
		<MenuPanelHeader label="Token">
			<div
				className="sectionTitle"
				style={{
					color: coinProps.color,
					fontWeight: "bold",
					cursor: props.onClick ? "pointer" : "default",
				}}
				onClick={props.onClick}
				title={props.onClick ? "Go to Balance" : undefined}
			>
				<img height="28px" src={coinProps.logo} alt={coinProps.name + " logo"} />
				&nbsp; {coinProps.name}
			</div>
		</MenuPanelHeader>
	)

	return (
		<div className="sectionHeader">
			<span className="helperText" style={{ fontSize: "12px", color: "#888" }}>
				Token
			</span>
			{/* <ContainerOutlined className="sectionIcon" /> */}
			<span className="sectionTitle" style={{
				color: coinProps.color,
			}}>
				&nbsp; <img height="28px" src={coinProps.logo} alt={coinProps.name + " logo"} />
				&nbsp; {coinProps.name}
			</span>
		</div>
	)

	return (<>
		<li className={"walletcard " + classes.wallet_card_style}
			onClick={props.onClick}
			style={{ ...custom_style }}
		>
			<div id="wallet-name-card" style={{
				letterSpacing: "normal",
				// background: "#001529",
				background: "transparent",
				paddingTop: "0.5em",
				// textAlign: "center",
				paddingLeft: "15px",
				borderTop: "1px solid grey",
				borderBottom: "1px solid grey",
				// borderRadius: "0.4em",
				paddingBottom: "0.5em",
				color: coinProps.color,
				fontWeight: "500",
				// margin: "0px 3px",
				cursor: "pointer",
			}}>
				<img height="28px" src={coinProps.logo} alt={coinProps.name + " logo"} />
				{/* don't use <b> here because css uses it for hover effect on others */}
				&nbsp; {coinProps.name}
			</div>
		</li>
	</>)
}

/* old version
export function WalletNameCard(props) {

	const userContext = useContext(UserContext)
	const theme = appConfig.theme
	const classes = useStyles()

	// let's change background color if this menuItem is selected
	const num = String(props.num)
	const is_selected_tab = String(num) === String(props.focus_num)
	const custom_style = {}
	if (is_selected_tab) {
		custom_style.background = theme.backgroundColorDarker1
	} else {
		custom_style.background = navbarItemBackground
	}

	const coinProps = userContext.get_selected_coin_props()

	return (<>
		<li className={"walletcard " + classes.wallet_card_style}
			onClick={props.onClick}
			style={{ ...custom_style }}
		>

			<div className="badge badge-light"
				style={{
					padding: "0.7em 0.2em",
					whiteSpace: "normal",
					wordBreak: "break-all"
				}}>
				{userContext.walletname}
			</div>
			<div style={{
				letterSpacing: "normal",
				paddingTop: "0.5em",
				textAlign: "center",
				border: "1px solid grey",
				borderRadius: "0 0 0.4em 0.4em",
				paddingBottom: "0.5em",
				color: coinProps.color,
				fontWeight: "500",
				margin: "0px 3px",
			}}>
				<img height="28px" src={coinProps.logo} alt={coinProps.name + " logo"} />
				&nbsp; {coinProps.name}
			</div>
			<div style={{ marginTop: "10px", marginBottom: "5px", marginLeft: "7px", fontSize: "14px" }}>
				<TabMenu title="Portefeuille" icon="fas fa-wallet" />
			</div>
		</li>
	</>)
}

*/